var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.51,
    height: 13.511,
    viewBox: "0 0 7.51 13.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "union",
    d: "M6.23,13.29.3,7.361a.758.758,0,0,1,0-1.212L6.23.22A.75.75,0,0,1,7.29,1.28L1.816,6.755,7.29,12.23a.75.75,0,1,1-1.06,1.06Z",
    transform: "translate(7.51 13.51) rotate(180)",
    fill: "#454f63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowRight);
export default __webpack_public_path__ + "static/media/back-arrow-right.fa5e777ae45c3bd7738b901890e9451a.svg";
export { ForwardRef as ReactComponent };